import { render, staticRenderFns } from "./SkillRatingsValidatedWidget.vue?vue&type=template&id=067b6b45&scoped=true"
import script from "./SkillRatingsValidatedWidget.vue?vue&type=script&lang=js"
export * from "./SkillRatingsValidatedWidget.vue?vue&type=script&lang=js"
import style0 from "./SkillRatingsValidatedWidget.vue?vue&type=style&index=0&id=067b6b45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b6b45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067b6b45')) {
      api.createRecord('067b6b45', component.options)
    } else {
      api.reload('067b6b45', component.options)
    }
    module.hot.accept("./SkillRatingsValidatedWidget.vue?vue&type=template&id=067b6b45&scoped=true", function () {
      api.rerender('067b6b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/SkillRatingsValidatedWidget.vue"
export default component.exports